import { Axis3D } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface AxisToggleProps {
  showAxis: boolean;
  onToggle: (value: boolean) => void;
}

export function AxisToggle({ showAxis, onToggle }: AxisToggleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!showAxis)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              showAxis ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle World Axis"
          >
            <Axis3D className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="flex items-center gap-2 border-border bg-background text-foreground"
        >
          <span>World Axis</span>
          <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
            A
          </kbd>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
